import MissingPermissionsPage from './MissingPermissionsPage';

export default MissingPermissionsPage;
